/**
 * @packageDocumentation
 * @module      EmcDataParameterAllTabs.ts
 * @description Bundles the EMC drive and Arm related data
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import P_Arm_P1P2 from "./emcDataParameter_Arm/P_Arm_P1P2";
import P_Arm_P34P5 from "./emcDataParameter_Arm/P_Arm_P34P5";
import P_Arm_SensorStatus from "./emcDataParameter_Arm/P_Arm_SensorStatus";
import P_Drive_Drive1 from "./emcDataParameter_Drive/P_Drive_Drive1";
import P_Drive_Drive2 from "./emcDataParameter_Drive/P_Drive_Drive2";
import P_Drive_Drive3 from "./emcDataParameter_Drive/P_Drive_Drive3";
import P_Drive_Drive4 from "./emcDataParameter_Drive/P_Drive_Drive4";
import P_Drive_Frame from "./emcDataParameter_Drive/P_Drive_Frame";
import P_Arm_ECAT3 from "./emcDataParameter_Arm/P_Arm_ECAT3";
import P_Drive_SensorStatusDrive1 from "./emcDataParameter_Drive/P_Drive_SensorStatusDrive1";
import P_Drive_SensorStatusDrive2 from "./emcDataParameter_Drive/P_Drive_SensorStatusDrive2";
import P_Drive_SensorStatusDrive3 from "./emcDataParameter_Drive/P_Drive_SensorStatusDrive3";
import P_Drive_SensorStatusDrive4 from "./emcDataParameter_Drive/P_Drive_SensorStatusDrive4";
import P_Drive_SensorStatusDriveAnyModule from "./emcDataParameter_Drive/P_Drive_SensorStatusDriveAnyModule";
import P_GUI_OUT from "./P_GUI_OUT";
import P_PIM_PDO from "./P_PIM_PDO";
import P_Frame from "./P_Frame";
import PdoData from "./PdoData";
export class EmcDataParameterAllTabs {
    constructor() {
        this.emcDataParameter_Arm = null;
        this.emcDataParameter_Drive = null;
        this.emcGUIOUT = null; //for frame
        this.emcPIMPDO = null;
        this.emcDataParameter_Frame = null;
        this.pdoData = null;
    }
    static fromJSON(json) {
        if (json) {
            let data = new EmcDataParameterAllTabs();
            data.emcDataParameter_Arm = EmcDataParameter_Arm.fromJSON(json);
            data.emcDataParameter_Drive = EmcDataParameter_Drive.fromJSON(json);
            if (json.Frame) {
                data.emcDataParameter_Frame = P_Frame.fromJson(json.Frame);
            }
            if (json.GUI_OUT) {
                data.emcGUIOUT = P_GUI_OUT.fromJson(json.GUI_OUT);
            }
            if (json.PIM_PDO) {
                data.emcPIMPDO = P_PIM_PDO.fromJson(json.PIM_PDO);
            }
            data.pdoData = PdoData.fromJSON(json);
            return data;
        }
        return null;
    }
}
export class EmcDataParameter_Arm {
    constructor() {
        this.p_Arm_P1P2 = null;
        this.p_Arm_P34P5 = null;
        this.p_Arm_ECAT3 = null;
        this.p_Arm_SensorStatus = null;
    }
    static fromJSON(json) {
        if (json && ((json.ArmModuleP1p2) || (json.ArmModuleP34p5) || (json.ECAT_in_Box3) || (json.FaultStruct) || (json.ReedFields))) {
            let data = new EmcDataParameter_Arm();
            if (json.ArmModuleP1p2) {
                data.p_Arm_P1P2 = P_Arm_P1P2.fromJSON(json.ArmModuleP1p2);
            }
            if (json.ArmModuleP34p5) {
                data.p_Arm_P34P5 = P_Arm_P34P5.fromJSON(json.ArmModuleP34p5);
            }
            if (json.ECAT_in_Box3) {
                data.p_Arm_ECAT3 = P_Arm_ECAT3.fromJSON(json.ECAT_in_Box3);
            }
            if (json.ReedFields) {
                if (json.ReedFields.Frame) {
                    data.p_Arm_SensorStatus = P_Arm_SensorStatus.fromJSON(json.ReedFields.Frame);
                }
            }
            return data;
        }
        return null;
    }
}
export class EmcDataParameter_Drive {
    constructor() {
        this.p_Drive_Drive1 = null;
        this.p_Drive_Drive2 = null;
        this.p_Drive_Drive3 = null;
        this.p_Drive_Drive4 = null;
        this.p_Drive_SensorStatusDrive1 = null;
        this.p_Drive_SensorStatusDrive2 = null;
        this.p_Drive_SensorStatusDrive3 = null;
        this.p_Drive_SensorStatusDrive4 = null;
        this.p_Drive_Frame = null;
        this.p_Drive_SensorStatusDriveAnyModule = null;
    }
    static fromJSON(json) {
        if (json && ((json.DModule1) || (json.DModule2) || (json.DModule3) || (json.DModule4) || (json.FaultStruct) || (json.ECAT3) || (json.ReedFields))) {
            let emcDataParameter_Drive = new EmcDataParameter_Drive();
            if (json.DModule1) {
                emcDataParameter_Drive.p_Drive_Drive1 = P_Drive_Drive1.fromJSON(json.DModule1);
            }
            if (json.DModule2) {
                emcDataParameter_Drive.p_Drive_Drive2 = P_Drive_Drive2.fromJSON(json.DModule2);
            }
            if (json.DModule3) {
                emcDataParameter_Drive.p_Drive_Drive3 = P_Drive_Drive3.fromJSON(json.DModule3);
            }
            if (json.DModule4) {
                emcDataParameter_Drive.p_Drive_Drive4 = P_Drive_Drive4.fromJSON(json.DModule4);
            }
            if (json.ReedFields) {
                if (json.ReedFields.Drive1) {
                    emcDataParameter_Drive.p_Drive_SensorStatusDrive1 = P_Drive_SensorStatusDrive1.fromJSON(json.ReedFields.Drive1);
                }
                if (json.ReedFields.Drive2) {
                    emcDataParameter_Drive.p_Drive_SensorStatusDrive2 = P_Drive_SensorStatusDrive2.fromJSON(json.ReedFields.Drive2);
                }
                if (json.ReedFields.Drive3) {
                    emcDataParameter_Drive.p_Drive_SensorStatusDrive3 = P_Drive_SensorStatusDrive3.fromJSON(json.ReedFields.Drive3);
                }
                if (json.ReedFields.Drive4) {
                    emcDataParameter_Drive.p_Drive_SensorStatusDrive4 = P_Drive_SensorStatusDrive4.fromJSON(json.ReedFields.Drive4);
                }
            }
            if (json.ECAT3) {
                emcDataParameter_Drive.p_Drive_Frame = P_Drive_Frame.fromJSON(json.ECAT3);
            }
            emcDataParameter_Drive.p_Drive_SensorStatusDriveAnyModule = P_Drive_SensorStatusDriveAnyModule.fromJSON(json);
            return emcDataParameter_Drive;
        }
        return null;
    }
}
//# sourceMappingURL=EmcDataParameterAllTabs.js.map